export const DEFAULT_RACK = {
  POST_WIDTH: 100,
  BEAM_HEIGHT: 50,
};

export const MIN_RACK = {
  LEVELS: 1,
  FRAMES_DEEP: 1,
  LOADS_PER_SHELF: 1,
  LOAD_HEIGHT: 200,
  POST_WIDTH: 10,
  CLEARANCE_SIDE: 0,
  CLEARANCE_TOP: 0,
  CLEARANCE_IN_BETWEEN: 0,
  BEAM_HEIGHT: 10,
  FIRST_SHELF_HEIGHT: 0,
  AISLE_WIDTH: 0,
};

// NOTE: the below makes the racking for 3D predicatable and leaves the gap value to be set on the rack itself instead of the area
export const RACK_MIN_GAP_OVERRIDE = 0;

export const DEFAULT_LOAD_BOUNDING_BOX_DIMENSIONS = {
  width: 0,
  length: 0,
};
